// extracted by mini-css-extract-plugin
export var attribution = "_9n-4";
export var authorName = "_9n-5";
export var quote = "_9n-3";
export var testimonial = "_9n-2";
export var trustedBy = "_9n-0";
export var trustedByLabel = "_9n-1";